module.exports = __webpack_public_path__ + "static/media/Avery Soule.02aaf24c.png";